import React, { useEffect, useImperativeHandle, useState } from "react";
import ViewBroker from "./ViewBroker";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../components/loader/loader";
import { ApiUrl } from "../../../config/apiConfig";
import { PaginationControls } from "../../../models/pagination";
import { getData, postData } from "../../../services/Axios/Axios";
import UseCommonService from "../../../services/commonService/commonService";
import messageService from "../../../services/message/messageService";
import NoRecord from "../../../components/NoDataScreen/NoRecord";
import Pagination from "../../../components/pagination/pagination";
import icon from "../../../assets/img/downbtn.svg";
import AddBroker from "../AddBroker";
import { showAPiError_mesage } from "../../../services/validationService/validationservice";
import { formatPhoneNumberd } from "../../../services/FormControlService/FormControlServices";
import LinkIcon from "../../../components/UIElements/LinkIcon"
import { ChevronsUpDown, Trash, Ban, Pencil, CircleX } from "lucide-react";
import BlockUnblockButton from "../../../components/UIElements/BlockUnblockButton";
import DeleteButton from "../../../components/UIElements/DeleteButton";
import EditButton from "../../../components/UIElements/EditButton";
import SocialMediaLinks from "../../../components/UIElements/SocialMediaLinks";
import { confirmAction } from "../../../utils/utils";
import { parseBrokerPayload } from "../../../utils/broker-utils";

interface brokerpropse {
  setSelectedRows: any;
  selectedRows: any;
  addEditModelBroker: any;
  setSelectedPriorities?: React.Dispatch<any>
}
const Broker = React.forwardRef((props: brokerpropse, ref) => {
  const { show, hide } = useLoader();
  const [allData, setAllData] = useState<any>([]);
  const [SingleUser, setSingleUser] = useState("");
  const [searchdaata, setSearchQuery] = useState<any>("");
  const [ids, setIds] = useState<number[]>([]); // or the appropriate type for your IDs

  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(1);

  // const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setSelectAll(
      allData.length > 0 && props.selectedRows.length === allData.length
    );
  }, [props.selectedRows, allData]);

  const navigate = useNavigate();
  useEffect(() => {
    getDataALLBrokerref();

    return () => {
      console.log("Component unmounted");
    };
  }, [pagination.page]);

  function sortByLinksCompleteness(companies: any[]): any {
    return companies.sort((a, b) => {
      const countLinks = (company: any): number => {
        let count = 0;
        if (company.website_url && company.website_url.trim() !== "") count++;
        if (company.carrierSetup && company.carrierSetup.trim() !== "") count++;
        if (company.loadBoard && company.loadBoard.trim() !== "") count++;
        return count;
      };

      return countLinks(b) - countLinks(a); // Sort descending
    });
  }



  // Helper: Count social media links
  function socialScore(item: any): number {
    let score = 0;
    const fields = ["linkedin", "facebook", "xcom", "instagram"];

    fields.forEach(f => {
      if (item[f] && item[f].trim().length > 0) score++;
    });

    return score;
  }

  function sortBrokersByPriority(brokers: any[]): any[] {
    return brokers.sort((a, b) => {
      const aPri = a.priority ?? Infinity;
      const bPri = b.priority ?? Infinity;

      return aPri - bPri;
    });
  }

  const getDataALLBrokerref = async (searchdaata?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    const isSearchRequest = Boolean(searchdaata && searchdaata.trim());
    if (isSearchRequest) {
      obj.search = searchdaata;
    }
    try {
      const response = await getData(
        ApiUrl.listBroker,
        obj,
        isSearchRequest ? undefined : { show, hide }
      );
      console.log("Data posted successfully:", response);
      const ids = response.data.map((item: any) => item._id);

      setIds(ids); // Assuming setIds is a state updater function for IDs
      setAllData(response.data);

      if (props.setSelectedPriorities) {
        props.setSelectedPriorities(
          response.data.reduce((acc: any[], broker: any) => {
            if (broker.priority != null) acc.push(broker.priority);
            return acc;
          }, [])
        );
      }

      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error: any) {
      const message = error?.response?.data?.message;
      showAPiError_mesage(message);
    }
  };

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  let EditeBroker = (data?: any) => {
    if (data === 2) {
      navigate("/Business", {
        state: { selectedTab: 2, data: data },
      });
    }
  };

  useImperativeHandle(ref, () => ({
    getDataALLBrokerref,
    handleSearchSubmit,
    handleSearchChange,
    handleDeleteSelected,
    handleDeleteSelectedAll,
    allData,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    getDataALLBrokerref(searchdaata);
  };

  let blockUnblock = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`Block this Broker`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isBlocked: !data.isBlocked,
        };
        let response = postData(ApiUrl.addEditBroker, obj);
        if (await response) {
          getDataALLBrokerref();
          const commonService = UseCommonService();
          commonService.checkBlockUnblock(data);
        }
      }
    });
  };

  let deleteData = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`delete this Broker`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isDeleted: !data.isDeleted,
        };
        let response = postData(ApiUrl.addEditBroker, obj);
        if (await response) {
          getDataALLBrokerref();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    });
  };

  const handleSelectAll = (e: any) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    props.setSelectedRows(checked ? allData.map((item: any) => item._id) : []);
  };

  const handleRowSelect = (id: any) => {
    props.setSelectedRows((prev: any) => {
      if (prev.includes(id)) {
        return prev.filter((itemId: any) => itemId !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  console.log(props.selectedRows, "selectedRowsselectedRows");
  const handleDeleteSelected = async () => {
    const messageServices = messageService();
    messageServices.confirm(`Delete selected Brokers`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: props.selectedRows,
          // isBulkDelete: true,
        };

        try {
          await postData(ApiUrl.deleteBroker, obj);
          getDataALLBrokerref();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
          props.setSelectedRows([]);
          setSelectAll(false);
        } catch (error) { }
      }
    });
  };

  const handleDeleteSelectedAll = async () => {
    const messageServices = messageService();
    messageServices.confirm(`Delete All Brokers`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: ids,
          isBulkDelete: true,
        };

        try {
          await postData(ApiUrl.deleteBroker, obj);
          getDataALLBrokerref();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
          props.setSelectedRows([]);
          setSelectAll(false);
        } catch (error) { }
      }
    });
  };

  console.log(props.selectedRows, "selectedRowsselectedRowsselectedRows");

  const removePriority = async (data: any) => {
    try {
      const obj = {
        ...data,
        priority: 9999,
      };
      await postData(ApiUrl.addEditBroker, parseBrokerPayload(obj));
      getDataALLBrokerref();
      const messageServicesd = messageService();
      messageServicesd.toast(
        'success',
        "Priority removed successfully"
      );
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <div className="tablebox">
        <div className="tablebox12">
          <div className="scrollbar-box assetsdriver">

            <table className="border-collapse  text-black w-full">
              <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                <tr className="text-[13px] font-bold  bg-customGray">
                  <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                    <div className="flex items-center justify-between">
                      <div className="checkboxinlinnre">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />{" "}
                        ALL
                      </div>
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>S. No</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Company Name</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Phone Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Address</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>MC Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>
                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>DOT Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Website</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Carrier Setup</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Load Board</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>
                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Social Links</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>


                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                {allData.map((data: any, index: number) => (
                  <tr key={index} className="text-[12px] hover:bg-[#f0f0f0]">
                    <td className="  px-3  border border-[#E2E2E2]">
                      <input
                        type="checkbox"
                        checked={props.selectedRows.includes(data._id)}
                        onChange={() => handleRowSelect(data._id)}
                      />
                    </td>
                    <td className=" px-3 border border-[#E2E2E2]">
                      {startIndex + index}</td>
                    <td className="pl-3 border border-[#E2E2E2] ">
                      <div className="flex justify-between w-full h-full items-center">

                        {data?.company_name
                          ? data.company_name.charAt(0).toUpperCase() +
                          data.company_name.slice(1).toLowerCase()
                          : "--"}
                        {(data.priority && data.priority !== 9999) &&
                          <span className="bg-green-100  text-xs font-medium me-2 pl-2.5 py-0.5 rounded-md  text-green-600 ml-3 flex items-center ">Priority : {data.priority} <button onClick={() => {
                            confirmAction("Are you sure you want to remove priority", () => removePriority(data))
                          }} className="ml-3 hover:text-red-500"><CircleX size={17} /></button></span>
                        }
                      </div>

                    </td>
                    <td className=" px-3 border border-[#E2E2E2]"> {data?.contact_information[0]?.phone_number
                      ? formatPhoneNumberd(
                        data.contact_information[0].phone_number
                      )
                      : "--"}</td>
                    <td className=" px-3 border border-[#E2E2E2]"> {data?.physical_address ? data?.physical_address : "--"}</td>
                    <td className=" px-2 border border-[#E2E2E2]">  {data?.mc_number ? data?.mc_number : "--"}</td>
                    <td className=" px-2 border border-[#E2E2E2]">
                      {data?.dot_number ? data?.dot_number : "--"}
                    </td>
                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <LinkIcon url={data?.website_url} />
                      </div>
                    </td>
                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <LinkIcon url={data?.carrierSetup} />
                      </div>
                    </td>
                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <LinkIcon url={data?.loadBoard} />
                      </div>
                    </td>
                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <SocialMediaLinks
                          linkedin={data?.linkedin}
                          facebook={data?.facebook}
                          xcom={data?.xcom}
                          instagram={data?.instagram}
                        />
                      </div>
                    </td>

                    <td className="text-center items-center px-2 py-[2px] border border-[#E2E2E2]">
                      <div className="flex justify-center items-center gap-2">
                        {/* Block / Unblock */}
                        <BlockUnblockButton isBlocked={data.isBlocked} onClick={() => blockUnblock(data)}></BlockUnblockButton>

                        {/* Delete */}
                        <DeleteButton onClick={() => deleteData(data)} />

                        {/* Edit */}
                        <EditButton onClick={() => props.addEditModelBroker(data)} />
                      </div>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>

            {!allData.length && (
              <NoRecord noDataText="No data available in Broker" />
            )}
          </div>
        </div>
        {allData.length > 0 && (
          <Pagination pagination={pagination} onPageChange={handlePageChange} />
        )}
      </div>
      {/* sdgsfdgjshdfgjhshgsdssddsds */}
    </>
  );
});

export default Broker;
